/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {
    useRef, useState, useEffect, useContext,
} from 'react';
import { compose } from 'recompose';
import { string, func, object } from 'prop-types';
import {
    Select, withStyles, Typography, TextField,
} from '@material-ui/core';

import { getAttributeByName } from '../../../../helpers/page/pageHelpers';
import { CrossMerch } from '../../CrossMerchContainer/CrossMerchContainer';
import ProductQuantityV2 from './ProductQuantityV2';

const styles = () => ({
    quantityContainer: {
        display: 'block',
        padding: '16px 0',
        alignItems: 'center',
        float: 'right',
        textAlign: 'right',
        width: '100%',
    },
    select: {
        border: '1px solid #ced4da',
        background: 'white',
        padding: '2px 5px',
        height: 30,
        width: 45,
    },
    label: {
        fontWeight: 'bold',
        fontSize: 18,
        marginRight: 10,
        display: 'inline-block',
        '@media screen and (max-width: 768px)': {
            fontSize: 16,
        },
    },
    input: {
        height: 30,
        width: 45,
    },
});

/* eslint-disable */
const ProductQuantity = ({
    product,
    quantity,
    setProductQuantity,
    classes,
}) => {
    const { featureFlags = {}, presentation_family: presentationFamily = '' } = useContext(CrossMerch);
    const isTryMeProduct = !!getAttributeByName(product?.attributes, 'try_me').length > 0;
    if (presentationFamily !== 'food'
        || !quantity
        || (!featureFlags['is-pdp-quantity-input-shown'] && !featureFlags['is-pdp-quantity-field-enabled'])
        || isTryMeProduct) {
        return null;
    }
    if (featureFlags['is-pdp-quantity-field-enabled']) {
        return (
            <ProductQuantityV2 setProductQuantity={setProductQuantity} quantity={quantity} />
        );
    }
    const [textFieldValue, setTextFieldValue] = useState(quantity);
    const quantityBox = useRef(null);

    useEffect(() => {
        if (Number(quantity) > 10 && quantityBox?.current) {
            quantityBox.current.focus();
        }
    }, [textFieldValue]);

    const getOptions = () => {
        const options = [];
        for (let i = 1; i < 12; i += 1) {
            if (i === 11) options.push(<option key={`option_${i}`} value={`${i}`}>11+</option>);
            else {
                options.push(<option key={`option_${i}`} value={`${i}`}>{i}</option>);
            }
        }
        return options;
    };

    const handleTextFieldChange = (e, setQty = false) => {
        // RegEx to get range between 1 - 99
        const rangeRegex = (/^[1-9][0-9]?$|^99$/);
        if (rangeRegex.test(e.target.value) || e.target.value === '') {
            setTextFieldValue(e.target.value);
            if (setQty) {
                setProductQuantity(e.target.value);
            }
        }
    };

    return (
        <div className={classes.quantityContainer}>
            <Typography
                className={classes.label}
            >
                Quantity
            </Typography>

            {Number(quantity) > 10 ? (
                <TextField
                    value={textFieldValue}
                    type="tel"
                    onChange={handleTextFieldChange}
                    onBlur={() => setProductQuantity(textFieldValue)}
                    InputProps={{ inputProps: { min: 1, max: 99 } }}
                    inputRef={quantityBox}
                    className={classes.input}
                    // style={{
                    //     width: '66px',
                    //     height: '41px',
                    // }}
                />
            ) : (
                <Select
                    native
                    value={quantity}
                    onChange={(e) => {
                        handleTextFieldChange(e, true);
                    }}
                    // style={{
                    //     width: '66px',
                    //     height: '41px',
                    // }}
                    className={classes.select}
                >
                    {getOptions(quantity)}
                </Select>
            )}
        </div>
    );
};

ProductQuantity.propTypes = {
    product: object.isRequired,
    quantity: string.isRequired,
    setProductQuantity: func.isRequired,
    classes: object.isRequired,
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(ProductQuantity);
